exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unstyled[data-v-20c1defc] {\n  padding-left: 0;\n  list-style: none;\n}\n.unstyled li a[data-v-20c1defc] {\n  display: block;\n}\n.unstyled li a .svg-icon[data-v-20c1defc] {\n  width: 1.6rem;\n  height: 1.6rem;\n  margin-right: 0.5rem;\n}\n.unstyled li + li[data-v-20c1defc] {\n  margin-top: 0.6rem;\n}", ""]);

// exports
